import axios from 'axios';

const host = process.env.REACT_APP_BACKEND_URL;
console.log(host);

const axiosInstance = axios.create({
  baseURL: host,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      console.warn('Permission denied:', error.response.data?.message || 'Access denied');
    }
    return Promise.reject((error.response && error.response) || error);
  },
);

export default axiosInstance;
